import {
  KEY_CAMPAIGNS,
  KEY_CAMPAIGNS_ADD,
  KEY_CAMPAIGNS_DELETE,
  KEY_CAMPAIGNS_UPDATE,
  KEY_DASHBOARD,
  KEY_DEVICE_MANAGEMENT,
  KEY_DEVICE_MANAGEMENT_BUILDINGS,
  KEY_DEVICE_MANAGEMENT_BUILDINGS_ADD,
  KEY_DEVICE_MANAGEMENT_BUILDINGS_DELETE,
  KEY_DEVICE_MANAGEMENT_BUILDINGS_UPDATE,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_ADD,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_DELETE,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_UPDATE,
  KEY_DEVICE_MANAGEMENT_DEVICES,
  KEY_DEVICE_MANAGEMENT_DEVICES_ADD,
  KEY_DEVICE_MANAGEMENT_DEVICES_DELETE,
  KEY_DEVICE_MANAGEMENT_DEVICES_UPDATE,
  KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS,
  KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_ADD,
  KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_DELETE,
  KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_UPDATE,
  KEY_DEVICE_MANAGEMENT_FLOORS,
  KEY_DEVICE_MANAGEMENT_FLOORS_ADD,
  KEY_DEVICE_MANAGEMENT_FLOORS_DELETE,
  KEY_DEVICE_MANAGEMENT_FLOORS_UPDATE,
  KEY_DEVICE_MANAGEMENT_PROJECT,
  KEY_DEVICE_MANAGEMENT_PROJECT_ADD,
  KEY_DEVICE_MANAGEMENT_PROJECT_DELETE,
  KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE,
  KEY_MANAGEMENT,
  KEY_MEDIAS,
  KEY_MEDIAS_ADD,
  KEY_MEDIAS_DELETE,
  KEY_MEDIAS_UPDATE,
  KEY_REPORTS_ACTION_LOGS,
  KEY_REPORTS_MEDIA_LOGS,
  KEY_REPORTS_MEDIA_LOGS_EXPORT_EXCEL,
  KEY_REPORTS_SCREENSHOT,
  KEY_USERS_MANAGEMENTS,
  KEY_USERS_MANAGEMENTS_ROLES,
  KEY_USERS_MANAGEMENTS_ROLES_ADD,
  KEY_USERS_MANAGEMENTS_ROLES_DELETE,
  KEY_USERS_MANAGEMENTS_ROLES_UPDATE,
  KEY_USERS_MANAGEMENTS_USERS,
  KEY_USERS_MANAGEMENTS_USERS_ADD,
  KEY_USERS_MANAGEMENTS_USERS_DELETE,
  KEY_USERS_MANAGEMENTS_USERS_UPDATE,
} from "@static/PERMISSION_KEY";

export const PERMISSION_LIST = [
  {
    key: KEY_DASHBOARD,
    title: "DASHBOARD",
    isActiveOnly: true,
    disabled: true,
  },
  {
    key: KEY_DEVICE_MANAGEMENT,
    title: "DEVICE",
    children: [
      // {
      //   key: KEY_DEVICE_MANAGEMENT_CUSTOMERS,
      //   title: "DEVICE MANAGEMENT CUSTOMERS",
      //   children: [
      //     { key: KEY_DEVICE_MANAGEMENT_CUSTOMERS_ADD, title: "เพิ่ม" },
      //     { key: KEY_DEVICE_MANAGEMENT_CUSTOMERS_UPDATE, title: "แก้ไข" },
      //     { key: KEY_DEVICE_MANAGEMENT_CUSTOMERS_DELETE, title: "ลบ" },
      //   ],
      // },
      // {
      //   key: KEY_DEVICE_MANAGEMENT_PROJECT,
      //   title: "DEVICE MANAGEMENT LOCATIONS",
      //   children: [
      //     { key: KEY_DEVICE_MANAGEMENT_PROJECT_ADD, title: "เพิ่ม" },
      //     { key: KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE, title: "แก้ไข" },
      //     { key: KEY_DEVICE_MANAGEMENT_PROJECT_DELETE, title: "ลบ" },
      //   ],
      // },
      // {
      //   key: KEY_DEVICE_MANAGEMENT_BUILDINGS,
      //   title: "DEVICE MANAGEMENT BUILDINGS",
      //   children: [
      //     { key: KEY_DEVICE_MANAGEMENT_BUILDINGS_ADD, title: "เพิ่ม" },
      //     { key: KEY_DEVICE_MANAGEMENT_BUILDINGS_UPDATE, title: "แก้ไข" },
      //     { key: KEY_DEVICE_MANAGEMENT_BUILDINGS_DELETE, title: "ลบ" },
      //   ],
      // },
      // {
      //   key: KEY_DEVICE_MANAGEMENT_FLOORS,
      //   title: "DEVICE MANAGEMENT FLOORS",
      //   children: [
      //     { key: KEY_DEVICE_MANAGEMENT_FLOORS_ADD, title: "เพิ่ม" },
      //     { key: KEY_DEVICE_MANAGEMENT_FLOORS_UPDATE, title: "แก้ไข" },
      //     { key: KEY_DEVICE_MANAGEMENT_FLOORS_DELETE, title: "ลบ" },
      //   ],
      // },
      {
        key: KEY_DEVICE_MANAGEMENT_DEVICES,
        title: "DEVICES",
        children: [
          { key: KEY_DEVICE_MANAGEMENT_DEVICES_ADD, title: "เพิ่ม" },
          { key: KEY_DEVICE_MANAGEMENT_DEVICES_UPDATE, title: "แก้ไข" },
          { key: KEY_DEVICE_MANAGEMENT_DEVICES_DELETE, title: "ลบ" },
        ],
      },
      {
        key: KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS,
        title: "DEVICE GROUPS",
        children: [
          { key: KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_ADD, title: "เพิ่ม" },
          { key: KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_UPDATE, title: "แก้ไข" },
          { key: KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_DELETE, title: "ลบ" },
        ],
      },
    ],
  },
  {
    key: KEY_CAMPAIGNS,
    title: "CAMPAIGNS",
    children: [
      { key: KEY_CAMPAIGNS_ADD, title: "เพิ่ม" },
      { key: KEY_CAMPAIGNS_UPDATE, title: "แก้ไข" },
      { key: KEY_CAMPAIGNS_DELETE, title: "ลบ" },
    ],
  },
  {
    key: KEY_MEDIAS,
    title: "MEDIAS",
    children: [
      { key: KEY_MEDIAS_ADD, title: "เพิ่ม" },
      { key: KEY_MEDIAS_UPDATE, title: "แก้ไข" },
      { key: KEY_MEDIAS_DELETE, title: "ลบ" },
    ],
  },
  {
    key: KEY_MANAGEMENT,
    title: "MANAGEMENT",
    children: [
      {
        key: KEY_DEVICE_MANAGEMENT_CUSTOMERS,
        title: "MANAGEMENT CUSTOMERS",
        children: [
          { key: KEY_DEVICE_MANAGEMENT_CUSTOMERS_ADD, title: "เพิ่ม" },
          { key: KEY_DEVICE_MANAGEMENT_CUSTOMERS_UPDATE, title: "แก้ไข" },
          { key: KEY_DEVICE_MANAGEMENT_CUSTOMERS_DELETE, title: "ลบ" },
        ],
      },
      {
        key: KEY_DEVICE_MANAGEMENT_PROJECT,
        title: "MANAGEMENT PROJECT",
        children: [
          { key: KEY_DEVICE_MANAGEMENT_PROJECT_ADD, title: "เพิ่ม" },
          { key: KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE, title: "แก้ไข" },
          { key: KEY_DEVICE_MANAGEMENT_PROJECT_DELETE, title: "ลบ" },
        ],
      },
      {
        key: KEY_DEVICE_MANAGEMENT_BUILDINGS,
        title: "MANAGEMENT BUILDINGS",
        children: [
          { key: KEY_DEVICE_MANAGEMENT_BUILDINGS_ADD, title: "เพิ่ม" },
          { key: KEY_DEVICE_MANAGEMENT_BUILDINGS_UPDATE, title: "แก้ไข" },
          { key: KEY_DEVICE_MANAGEMENT_BUILDINGS_DELETE, title: "ลบ" },
        ],
      },
      {
        key: KEY_DEVICE_MANAGEMENT_FLOORS,
        title: "MANAGEMENT FLOORS",
        children: [
          { key: KEY_DEVICE_MANAGEMENT_FLOORS_ADD, title: "เพิ่ม" },
          { key: KEY_DEVICE_MANAGEMENT_FLOORS_UPDATE, title: "แก้ไข" },
          { key: KEY_DEVICE_MANAGEMENT_FLOORS_DELETE, title: "ลบ" },
        ],
      },
    ],
  },
  {
    key: "REPORTS",
    title: "REPORTS",
    children: [
      { key: KEY_REPORTS_ACTION_LOGS, title: "action logs" },
      { key: KEY_REPORTS_MEDIA_LOGS, title: "media logs" },
      { key: KEY_REPORTS_SCREENSHOT, title: "screen shot" },
      { key: KEY_REPORTS_MEDIA_LOGS_EXPORT_EXCEL, title: "export media logs" },
    ],
  },
  {
    key: KEY_USERS_MANAGEMENTS,
    title: "USER",
    children: [
      {
        key: KEY_USERS_MANAGEMENTS_ROLES,
        title: "ROLES",
        children: [
          { key: KEY_USERS_MANAGEMENTS_ROLES_ADD, title: "เพิ่ม" },
          { key: KEY_USERS_MANAGEMENTS_ROLES_UPDATE, title: "แก้ไข" },
          { key: KEY_USERS_MANAGEMENTS_ROLES_DELETE, title: "ลบ" },
        ],
      },
      {
        key: KEY_USERS_MANAGEMENTS_USERS,
        title: "USERS",
        children: [
          { key: KEY_USERS_MANAGEMENTS_USERS_ADD, title: "เพิ่ม" },
          { key: KEY_USERS_MANAGEMENTS_USERS_UPDATE, title: "แก้ไข" },
          { key: KEY_USERS_MANAGEMENTS_USERS_DELETE, title: "ลบ" },
        ],
      },
    ],
  },
];
